export const breakpoints = {
  xxl: 1920,
  xl: 1440, // 1440px - 1919px
  lg: 1280, // 1280px - 1439px

  // Планшеты
  md: 905, // 905px - 1279px

  // Мобильные
  sm: 600, // 600px - 904px
  xs: 360, // 360px - 599px

  uhd: 2560,
} as const

export type Breakpoint = keyof typeof breakpoints

export const media = {
  xs: `@media (min-width: ${breakpoints.xs}px)`,
  sm: `@media (min-width: ${breakpoints.sm}px)`,
  md: `@media (min-width: ${breakpoints.md}px)`,
  lg: `@media (min-width: ${breakpoints.lg}px)`,
  xl: `@media (min-width: ${breakpoints.xl}px)`,
  xxl: `@media (min-width: ${breakpoints.xxl}px)`,
  uhd: `@media (min-width: ${breakpoints.uhd}px)`,
} as const

export const mediaMax = {
  xs: `@media (max-width: ${breakpoints.xs - 1}px)`,
  sm: `@media (max-width: ${breakpoints.sm - 1}px)`,
  md: `@media (max-width: ${breakpoints.md - 1}px)`,
  lg: `@media (max-width: ${breakpoints.lg - 1}px)`,
  xl: `@media (max-width: ${breakpoints.xl - 1}px)`,
  xxl: `@media (max-width: ${breakpoints.xxl - 1}px)`,
} as const

export const mediaBetween = {
  xs_sm: `@media (min-width: ${breakpoints.xs}px) and (max-width: ${breakpoints.sm - 1}px)`,
  sm_md: `@media (min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md - 1}px)`,
  md_lg: `@media (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.lg - 1}px)`,
  lg_xl: `@media (min-width: ${breakpoints.lg}px) and (max-width: ${breakpoints.xl - 1}px)`,
  xl_xxl: `@media (min-width: ${breakpoints.xl}px) and (max-width: ${breakpoints.xxl - 1}px)`,
} as const
